import { Typography } from '@scale/scaleui';
import React from 'react';

interface Props {
  header: string;
  children: React.ReactNode;
}

const ConfigSectionHeader = ({ header, children }: Props) => {
  return (
    <>
      <Typography.Subtitle2>{header}</Typography.Subtitle2>
      {children}
    </>
  );
};

export default ConfigSectionHeader;
